module.exports = __webpack_public_path__ + "img/verify.b03490b6.png";